import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ScadenzeDipendenti } from 'src/app/models/scadenze-dipendenti';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScadenzeDipendentiService {
  private http = inject(HttpClient);



  scadenzeUrl = environment.ildatoArticoliDpi + 'api/scadenzedipendenti';


  list(): Observable<ScadenzeDipendenti[]> {
    return this.http.get<ScadenzeDipendenti[]>(this.scadenzeUrl);
  }

  listByDipendente(idDipendente: number): Observable<ScadenzeDipendenti[]> {
    //return this.http.get<ScadenzeDipendenti[]>(`${this.scadenzeUrl}/bydip/${codCope}`); 
    return this.http.get<ScadenzeDipendenti[]>(this.scadenzeUrl  + '/bydip/'+ idDipendente); 
  }

  get(id:number): Observable<ScadenzeDipendenti> {
    return this.http.get<ScadenzeDipendenti>(this.scadenzeUrl  + '/'+ id);
    
  }

  insert(values: ScadenzeDipendenti): Observable<ScadenzeDipendenti> {
    console.log(values);    
    return this.http.post<ScadenzeDipendenti>(this.scadenzeUrl, values);
  }

  remove(codCope: number): Observable<ScadenzeDipendenti> {
    console.log(codCope);    
    return this.http.delete<ScadenzeDipendenti>(this.scadenzeUrl + '/'+ codCope );
  }

  update(key: number, values: ScadenzeDipendenti): Observable<ScadenzeDipendenti> {
    console.log(values);    
    return this.http.put<ScadenzeDipendenti>(this.scadenzeUrl + '/'+ key , values);
  }

}
